module.exports = __webpack_public_path__ + "img/TZ.0a98e773.png";